
import { SvgBase } from "../svg.base";

export const Telegram = () => (
  <SvgBase>
    <path
      fill="currentColor"
      d="M4.389 14.214l5.069 1.892 1.962 6.31c.125.404.62.554.948.285l2.825-2.303a.843.843 0 0 1 1.028-.029l5.097 3.7c.35.255.848.063.936-.36l3.733-17.96a.598.598 0 0 0-.8-.679L4.383 13.096a.598.598 0 0 0 .006 1.118zm6.715.885l9.907-6.102c.178-.11.361.131.208.273l-8.176 7.6a1.695 1.695 0 0 0-.525 1.015l-.279 2.064c-.037.275-.424.303-.5.036l-1.071-3.764a.998.998 0 0 1 .436-1.122z"
    />
  </SvgBase>
);



